import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Appointment from '../global-components/appointment';



class Sidebar extends Component {
  render() {
   let anchor = '#'
   let imagealt = 'image'
   let publicUrl = process.env.PUBLIC_URL+'/'
    return (
          <div className="col-lg-4">
            <Appointment courseRestriction={this.props.courseRestriction} /><br></br>
            <div className="td-sidebar sidebarbg">
              <div className="widget widget_catagory">
                <h6 className="widget-title">Skill Development Courses</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/ncvt-course">NCVT Courses <i className="fa fa-caret-right" /></Link></li>
                  <li><Link to="/industrial-school-courses">Industrial School Courses <i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Entrance Exam Courses</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/neet-courses-in-chennai">NEET <i className="fa fa-caret-right" /></Link></li>
                  <li><Link to="/jee-courses-in-chennai">JEE <i className="fa fa-caret-right" /></Link></li>
                  <li><Link to="/nata-courses-in-chennai">NATA <i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Arts & Science</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/tmg-college-of-arts-and-science">TMG College of Arts & Science<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Distance Education Courses</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/university-of-madras"> University of Madras<i className="fa fa-caret-right" /></Link></li>
                  <li><Link to="/bharathidasan-university"> Bharathidasan University<i className="fa fa-caret-right" /></Link></li>
                  <li><Link to="/tamilnadu-open-university"> Tamil Nadu Open University<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Information Technology Courses</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/data-science-and-artificial-intelligence-courses"> Data Science & AI<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">School Courses</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/school-courses"> Classes IX, X, XI, XII<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Eligibility Tests (SSC, RRB, IBPS)</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/nra-cet-courses-in-chennai"> NRA CET<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <h6 className="widget-title">Hotel Management & Catering Technology</h6>                                 
                <ul className="catagory-items go-top">
                  <li><Link to="/hotel-management-courses-in-chennai">Courses <br/> (Degree/Diploma/Craft)<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <ul className="catagory-items go-top">
                  <li><Link to="/gate-coaching-centre-in-chennai">GATE<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <ul className="catagory-items go-top">
                  <li><Link to="/ugc-net-coaching-centre-in-chennai">NET<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <ul className="catagory-items go-top">
                  <li><Link to="/slet-coaching-centre-in-chennai">SLET<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <ul className="catagory-items go-top">
                  <li><Link to="/ies-training-institute-chennai">IES<i className="fa fa-caret-right" /></Link></li>
                </ul>
                <hr/>
                <ul className="catagory-items go-top">
                  <li><Link to="/engineering-and-architecture-guidance-program">Engineering and Architecture Guidance Program<i className="fa fa-caret-right" /></Link></li>
                </ul>
              </div>                  
            </div>
          </div>
    )
  }
}

export default Sidebar;
